export class UpdateReservationPhoneNumberReservationNotFoundTransactionsError extends Error {
  static create(errorMessage) {
    return new UpdateReservationPhoneNumberReservationNotFoundTransactionsError(errorMessage)
  }
}
